import { CardContent, Grid2 } from '@mui/material';

import { MainCardWrapper, Title } from './CardMainContainer.styles';

interface CardMainContainerProps {
  title: string;
  children: React.ReactNode;
}

const CardMainContainer: React.FC<CardMainContainerProps> = ({
  title,
  children,
}) => {
  return (
    <Grid2 container justifyContent="center" spacing={1}>
      <Grid2 size={12}>
        <MainCardWrapper>
          <CardContent>
            <Title variant="h6">{title}</Title>
            {children}
          </CardContent>
        </MainCardWrapper>
      </Grid2>
    </Grid2>
  );
};

export default CardMainContainer;
